export default {
    "v": "5.5.7",
    "meta": {"g": "LottieFiles AE 0.1.21", "a": "", "k": "", "d": "", "tc": ""},
    "fr": 30,
    "ip": 0,
    "op": 150,
    "w": 500,
    "h": 500,
    "nm": "10 - Secure payment",
    "ddd": 0,
    "assets": [],
    "layers": [{
        "ddd": 0,
        "ind": 1,
        "ty": 4,
        "nm": "Controller",
        "td": 1,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [250, 250, 0], "ix": 2},
            "a": {"a": 0, "k": [0, 0, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "ef": [{
            "ty": 5,
            "nm": "Color",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 1,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [1, 0.728999972343, 0.301999986172, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 2",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 2,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [1, 0.862999975681, 0.412000000477, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 3",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 3,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.050980396569, 0.29411765933, 0.698039233685, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 4",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 4,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.607843160629, 0.839215695858, 0.972549021244, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 5",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 5,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.482352942228, 0.709803938866, 0.960784316063, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 6",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 6,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.607843160629, 0.839215695858, 0.972549021244, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 7",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 7,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.988235294819, 0.615686297417, 0.050980392843, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 8",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 8,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.482352942228, 0.709803938866, 0.960784316063, 1], "ix": 1}
            }]
        }, {
            "ty": 5,
            "nm": "Color 9",
            "np": 3,
            "mn": "ADBE Color Control",
            "ix": 9,
            "en": 1,
            "ef": [{
                "ty": 2,
                "nm": "Color",
                "mn": "ADBE Color Control-0001",
                "ix": 1,
                "v": {"a": 0, "k": [0.607843160629, 0.839215695858, 0.972549021244, 1], "ix": 1}
            }]
        }],
        "shapes": [],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 2,
        "ty": 4,
        "nm": "Coin",
        "tt": 1,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [250, 250, 0], "ix": 2},
            "a": {"a": 0, "k": [250, 175, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[44.655, 99.736], [44.655, 90.952]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {
                        "a": 0,
                        "k": [1, 0.728999972343, 0.301999986172, 1],
                        "ix": 3,
                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                    },
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 10.833, "ix": 5},
                    "lc": 2,
                    "lj": 2,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [0, 0], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [0, 0]],
                            "o": [[0, 0], [0, 0]],
                            "v": [[44.655, 18.299], [44.655, 27.083]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {
                        "a": 0,
                        "k": [1, 0.728999972343, 0.301999986172, 1],
                        "ix": 3,
                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                    },
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 10.833, "ix": 5},
                    "lc": 2,
                    "lj": 2,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [0, 0], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 2",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 2,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, 0], [-7.496, 0], [0, 8.82], [12.415, 0], [0, 8.819], [-9.706, 0], [-2.525, -6.005]],
                            "o": [[2.525, 6.005], [9.706, 0], [0, -8.818], [-12.415, 0], [0, -8.819], [7.496, 0], [0, 0]],
                            "v": [[-16.39, 21.667], [0.031, 31.935], [17.604, 15.968], [-0.031, 0], [-17.604, -15.968], [-0.031, -31.935], [16.39, -21.666]],
                            "c": false
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {
                        "a": 0,
                        "k": [1, 0.728999972343, 0.301999986172, 1],
                        "ix": 3,
                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                    },
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 10.833, "ix": 5},
                    "lc": 2,
                    "lj": 2,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [44.686, 59.017], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 3",
                "np": 2,
                "cix": 2,
                "bm": 0,
                "ix": 3,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [250, 175], "ix": 2},
                "a": {"a": 0, "k": [44.686, 59.018], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 103,
                        "s": [0, 0]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 123,
                        "s": [150, 150]
                    }, {"t": 137, "s": [0, 0]}],
                    "ix": 3
                },
                "r": {
                    "a": 1,
                    "k": [{"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 103, "s": [45]}, {
                        "t": 137,
                        "s": [-180]
                    }],
                    "ix": 6
                },
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Dollar",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "gr", "it": [{
                "ty": "gr",
                "it": [{
                    "ind": 0,
                    "ty": "sh",
                    "ix": 1,
                    "ks": {
                        "a": 0,
                        "k": {
                            "i": [[0, -35.898], [35.898, 0], [0, 35.898], [-35.899, 0]],
                            "o": [[0, 35.898], [-35.899, 0], [0, -35.898], [35.898, 0]],
                            "v": [[65, 0], [0, 65], [-65, 0], [0, -65]],
                            "c": true
                        },
                        "ix": 2
                    },
                    "nm": "Path 1",
                    "mn": "ADBE Vector Shape - Group",
                    "hd": false
                }, {
                    "ty": "st",
                    "c": {
                        "a": 0,
                        "k": [1, 0.728999972343, 0.301999986172, 1],
                        "ix": 3,
                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                    },
                    "o": {"a": 0, "k": 100, "ix": 4},
                    "w": {"a": 0, "k": 10.833, "ix": 5},
                    "lc": 2,
                    "lj": 2,
                    "bm": 0,
                    "nm": "Stroke 1",
                    "mn": "ADBE Vector Graphic - Stroke",
                    "hd": false
                }, {
                    "ty": "fl",
                    "c": {
                        "a": 0,
                        "k": [1, 0.862999975681, 0.412000000477, 1],
                        "ix": 4,
                        "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 2')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                    },
                    "o": {"a": 0, "k": 100, "ix": 5},
                    "r": 1,
                    "bm": 0,
                    "nm": "Fill 1",
                    "mn": "ADBE Vector Graphic - Fill",
                    "hd": false
                }, {
                    "ty": "tr",
                    "p": {"a": 0, "k": [92.082, 92.082], "ix": 2},
                    "a": {"a": 0, "k": [0, 0], "ix": 1},
                    "s": {"a": 0, "k": [100, 100], "ix": 3},
                    "r": {"a": 0, "k": 0, "ix": 6},
                    "o": {"a": 0, "k": 100, "ix": 7},
                    "sk": {"a": 0, "k": 0, "ix": 4},
                    "sa": {"a": 0, "k": 0, "ix": 5},
                    "nm": "Transform"
                }],
                "nm": "Group 1",
                "np": 3,
                "cix": 2,
                "bm": 0,
                "ix": 1,
                "mn": "ADBE Vector Group",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [250, 175], "ix": 2},
                "a": {"a": 0, "k": [92.082, 92.082], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 100,
                        "s": [0, 0]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 120,
                        "s": [150, 150]
                    }, {"t": 140, "s": [0, 0]}],
                    "ix": 3
                },
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Coin", "np": 1, "cix": 2, "bm": 0, "ix": 2, "mn": "ADBE Vector Group", "hd": false
        }],
        "ip": 100,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 3,
        "ty": 4,
        "nm": "Ok",
        "parent": 5,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [64.385, -82.189, 0], "ix": 2},
            "a": {"a": 0, "k": [79.833, 72.23, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [[39.834, -32.23], [-13.343, 32.23], [-39.834, 0.117]],
                        "c": false
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [0.372999991623, 0.4, 0.458999992819, 1],
                    "ix": 3,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 16, "ix": 5},
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [79.833, 72.23], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "tm",
            "s": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.3], "y": [1]},
                    "o": {"x": [0.7], "y": [0]},
                    "t": 55,
                    "s": [100]
                }, {"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 75, "s": [0]}, {
                    "i": {
                        "x": [0.3],
                        "y": [1]
                    }, "o": {"x": [0.7], "y": [0]}, "t": 95, "s": [10]
                }, {"t": 115, "s": [0]}],
                "ix": 1
            },
            "e": {"a": 0, "k": 100, "ix": 2},
            "o": {"a": 0, "k": 0, "ix": 3},
            "m": 1,
            "ix": 2,
            "nm": "Trim Paths 1",
            "mn": "ADBE Vector Filter - Trim",
            "hd": false
        }],
        "ip": 55,
        "op": 115,
        "st": 15,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 4,
        "ty": 4,
        "nm": "Line Ellipse",
        "parent": 5,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [51, -80, 0], "ix": 2},
            "a": {"a": 0, "k": [95, 95, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, -33.137], [33.137, 0], [0, 33.137], [-33.137, 0]],
                        "o": [[0, 33.137], [-33.137, 0], [0, -33.137], [33.137, 0]],
                        "v": [[60, 0], [0, 60], [-60, 0], [0, -60]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [0.356862745098, 0.729411764706, 0.654901960784, 1],
                    "ix": 3,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 4')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 14, "ix": 5},
                "lc": 2,
                "lj": 2,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [95, 95], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "tm",
            "s": {
                "a": 1,
                "k": [{"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 55, "s": [50]}, {
                    "i": {
                        "x": [0.3],
                        "y": [1]
                    }, "o": {"x": [0.7], "y": [0]}, "t": 75, "s": [5]
                }, {"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 95, "s": [20]}, {
                    "t": 115,
                    "s": [0]
                }],
                "ix": 1
            },
            "e": {
                "a": 1,
                "k": [{"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 55, "s": [50]}, {
                    "i": {
                        "x": [0.3],
                        "y": [1]
                    }, "o": {"x": [0.7], "y": [0]}, "t": 75, "s": [94]
                }, {"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 95, "s": [80]}, {
                    "t": 115,
                    "s": [100]
                }],
                "ix": 2
            },
            "o": {"a": 0, "k": -28, "ix": 3},
            "m": 1,
            "ix": 2,
            "nm": "Trim Paths 1",
            "mn": "ADBE Vector Filter - Trim",
            "hd": false
        }],
        "ip": 55,
        "op": 115,
        "st": 15,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 5,
        "ty": 4,
        "nm": "Ellipse 1",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.3], "y": [1]},
                    "o": {"x": [0.7], "y": [0]},
                    "t": 55,
                    "s": [-45]
                }, {"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 75, "s": [0]}, {
                    "i": {
                        "x": [0.3],
                        "y": [1]
                    }, "o": {"x": [0.7], "y": [0]}, "t": 95, "s": [0]
                }, {"t": 115, "s": [-45]}],
                "ix": 10
            },
            "p": {"a": 0, "k": [250, 250, 0], "ix": 2},
            "a": {"a": 0, "k": [51, -80, 0], "ix": 1},
            "s": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.3, 0.3, 0.3], "y": [1, 1, 1]},
                    "o": {"x": [0.7, 0.7, 0.7], "y": [0, 0, 0]},
                    "t": 55,
                    "s": [0, 0, 100]
                }, {
                    "i": {"x": [0.3, 0.3, 0.3], "y": [1, 1, 1]},
                    "o": {"x": [0.7, 0.7, 0.7], "y": [0, 0, 0]},
                    "t": 75,
                    "s": [150, 150, 100]
                }, {
                    "i": {"x": [0.3, 0.3, 0.3], "y": [1, 1, 1]},
                    "o": {"x": [0.7, 0.7, 0.7], "y": [0, 0, 0]},
                    "t": 95,
                    "s": [100, 100, 100]
                }, {
                    "i": {"x": [0.4, 0.4, 0.4], "y": [1, 1, 1]},
                    "o": {"x": [0.7, 0.7, 0.7], "y": [0, 0, 0]},
                    "t": 115,
                    "s": [0, 0, 100]
                }, {"t": 175, "s": [100, 100, 100]}],
                "ix": 6
            }
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "d": 1,
                "ty": "el",
                "s": {"a": 0, "k": [180, 180], "ix": 2},
                "p": {"a": 0, "k": [0, 0], "ix": 3},
                "nm": "Ellipse Path 1",
                "mn": "ADBE Vector Shape - Ellipse",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.505882352941, 0.870588295133, 0.737254901961, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 5')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [51, -80], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Ellipse 1",
            "np": 3,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 55,
        "op": 115,
        "st": 15,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 6,
        "ty": 4,
        "nm": "Keyhole",
        "parent": 7,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [85.25, 65.25, 0], "ix": 2},
            "a": {"a": 0, "k": [20.362, 40.25, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 6.484], [11.108, 0], [0, -11.108], [-4.764, -3.678], [0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, -11.108], [-11.107, 0], [0, 6.484], [0, 0], [0, 0], [0, 0], [0, 0], [4.764, -3.678]],
                        "v": [[20.112, -19.888], [-0.001, -40], [-20.112, -19.888], [-12.227, -4.021], [-20.112, 40], [-0.001, 40], [20.112, 40], [12.227, -4.021]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.372999991623, 0.4, 0.458999992819, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [20.362, 40.25], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 7,
        "ty": 4,
        "nm": "Lock",
        "parent": 8,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [98.988, 205, 0], "ix": 2},
            "a": {"a": 0, "k": [85.25, 65.25, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[11.046, 0], [0, 0], [0, -11.046], [0, 0], [-11.046, 0], [0, 0], [0, 11.046], [0, 0]],
                        "o": [[0, 0], [-11.046, 0], [0, 0], [0, 11.046], [0, 0], [11.046, 0], [0, 0], [0, -11.046]],
                        "v": [[65, -65], [-65, -65], [-85, -45], [-85, 45], [-65, 65], [65, 65], [85, 45], [85, -45]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.811999990426, 0.811999990426, 0.811999990426, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 6')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [85.25, 65.25], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 8,
        "ty": 4,
        "nm": "Line 1",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {
                "a": 1,
                "k": [{"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 4, "s": [0]}, {
                    "i": {
                        "x": [0.3],
                        "y": [1]
                    }, "o": {"x": [0.7], "y": [0]}, "t": 19, "s": [-12]
                }, {"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 34, "s": [12]}, {"t": 49, "s": [0]}],
                "ix": 10
            },
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.3, "y": 1},
                    "o": {"x": 0.7, "y": 0},
                    "t": 2,
                    "s": [250, 205, 0],
                    "to": [0, 0, 0],
                    "ti": [0, 0, 0]
                }, {
                    "i": {"x": 0.3, "y": 1},
                    "o": {"x": 0.7, "y": 0},
                    "t": 17,
                    "s": [230, 205, 0],
                    "to": [0, 0, 0],
                    "ti": [0, 0, 0]
                }, {
                    "i": {"x": 0.3, "y": 1},
                    "o": {"x": 0.7, "y": 0},
                    "t": 32,
                    "s": [270, 205, 0],
                    "to": [0, 0, 0],
                    "ti": [0, 0, 0]
                }, {"t": 47, "s": [250, 205, 0]}],
                "ix": 2
            },
            "a": {"a": 0, "k": [98.988, 50, 0], "ix": 1},
            "s": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 45,
                    "s": [100, 100, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 60,
                    "s": [120, 120, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 75,
                    "s": [0, 0, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 120,
                    "s": [0, 0, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 135,
                    "s": [115, 115, 100]
                }, {"t": 150, "s": [100, 100, 100]}],
                "ix": 6
            }
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, -27.056], [0, 0]],
                        "o": [[-27.055, 0], [0, 0], [0, 0]],
                        "v": [[24.494, -50], [-24.494, -1.012], [-24.494, 50]],
                        "c": false
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [0.532999973671, 0.588000009574, 0.638999968884, 1],
                    "ix": 3,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 7')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 20, "ix": 5},
                "lc": 1,
                "lj": 1,
                "ml": 10,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [74.494, 100], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 9,
        "ty": 4,
        "nm": "Points",
        "parent": 13,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [225.25, 130.25, 0], "ix": 2},
            "a": {"a": 0, "k": [36.75, 6.79, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr", "it": [{
                "ind": 0, "ty": "sh", "ix": 1, "ks": {
                    "a": 0, "k": {
                        "i": [[0.16, 0.4], [0.241, 0.35], [0.299, 0.3], [0.351, 0.23], [0.401, 0.16], [0.41, 0.08], [0.84, -0.17], [0.4, -0.16], [0.35, -0.24], [0.301, -0.3], [0.23, -0.35], [0.16, -0.39], [0.08, -0.41], [0, -0.42], [-0.09, -0.42], [-0.16, -0.4], [-0.241, -0.35], [-0.299, -0.3], [-1.71, 0], [-0.42, 0.09], [-0.389, 0.17], [-0.349, 0.24], [-0.3, 0.3], [-0.229, 0.35], [-0.16, 0.39], [-0.08, 0.41], [0, 0.42], [0.09, 0.42]],
                        "o": [[-0.16, -0.39], [-0.229, -0.35], [-0.3, -0.3], [-0.349, -0.24], [-0.389, -0.16], [-0.84, -0.17], [-0.419, 0.08], [-0.39, 0.16], [-0.36, 0.23], [-0.299, 0.3], [-0.241, 0.35], [-0.16, 0.4], [-0.09, 0.42], [0, 0.42], [0.08, 0.41], [0.16, 0.39], [0.23, 0.35], [1.21, 1.21], [0.42, 0], [0.41, -0.08], [0.401, -0.16], [0.351, -0.23], [0.299, -0.3], [0.241, -0.35], [0.16, -0.4], [0.09, -0.42], [0, -0.42], [-0.08, -0.41]],
                        "v": [[6, -2.47], [5.399, -3.59], [4.6, -4.58], [3.609, -5.38], [2.479, -5.98], [1.27, -6.35], [-1.271, -6.35], [-2.49, -5.98], [-3.61, -5.38], [-4.601, -4.58], [-5.4, -3.59], [-6, -2.47], [-6.37, -1.25], [-6.5, 0.02], [-6.37, 1.29], [-6, 2.51], [-5.4, 3.63], [-4.601, 4.62], [0, 6.52], [1.27, 6.39], [2.479, 6.02], [3.609, 5.42], [4.6, 4.62], [5.399, 3.63], [6, 2.51], [6.37, 1.29], [6.5, 0.02], [6.37, -1.25]],
                        "c": true
                    }, "ix": 2
                }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.372999991623, 0.4, 0.458999992819, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [6.75, 6.77], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 36,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 51,
                        "s": [180, 180]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.425, 0.425], "y": [0, 0]},
                        "t": 66,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 106,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 121,
                        "s": [180, 180]
                    }, {"t": 136, "s": [100, 100]}],
                    "ix": 3
                },
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[3.59, 0], [0, -3.59], [-3.59, 0], [0, 3.59]],
                        "o": [[-3.59, 0], [0, 3.59], [3.59, 0], [0, -3.59]],
                        "v": [[0, -6.5], [-6.5, 0], [0, 6.5], [6.5, 0]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.372999991623, 0.4, 0.458999992819, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [36.75, 6.79], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 43,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 58,
                        "s": [180, 180]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.425, 0.425], "y": [0, 0]},
                        "t": 73,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 113,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 128,
                        "s": [180, 180]
                    }, {"t": 143, "s": [100, 100]}],
                    "ix": 3
                },
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 2",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 2,
            "mn": "ADBE Vector Group",
            "hd": false
        }, {
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0.09, 0.42], [0.16, 0.4], [0.241, 0.35], [0.3, 0.3], [0.351, 0.23], [0.401, 0.16], [0.411, 0.08], [0.84, -0.17], [0.4, -0.17], [0.35, -0.24], [0.301, -0.3], [0.24, -0.35], [0.16, -0.39], [0.08, -0.41], [0, -0.42], [-1.21, -1.21], [-0.35, -0.23], [-0.39, -0.16], [-0.41, -0.08], [-0.42, 0], [-1.219, 1.21], [0, 1.71]],
                        "o": [[-0.08, -0.41], [-0.16, -0.39], [-0.229, -0.35], [-0.299, -0.3], [-0.349, -0.24], [-0.389, -0.17], [-0.839, -0.17], [-0.41, 0.08], [-0.39, 0.16], [-0.35, 0.23], [-0.3, 0.3], [-0.231, 0.35], [-0.17, 0.4], [-0.09, 0.42], [0, 1.71], [0.301, 0.3], [0.35, 0.24], [0.4, 0.16], [0.42, 0.09], [1.71, 0], [1.21, -1.21], [0, -0.42]],
                        "v": [[6.37, -1.25], [6, -2.47], [5.399, -3.59], [4.599, -4.58], [3.609, -5.38], [2.479, -5.98], [1.269, -6.35], [-1.271, -6.35], [-2.49, -5.98], [-3.61, -5.38], [-4.601, -4.58], [-5.41, -3.59], [-6, -2.47], [-6.37, -1.25], [-6.5, 0.02], [-4.601, 4.62], [-3.61, 5.42], [-2.49, 6.02], [-1.271, 6.39], [0, 6.52], [4.599, 4.62], [6.5, 0.02]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.372999991623, 0.4, 0.458999992819, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [66.75, 6.77], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {
                    "a": 1,
                    "k": [{
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 50,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 65,
                        "s": [180, 180]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.425, 0.425], "y": [0, 0]},
                        "t": 80,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 120,
                        "s": [100, 100]
                    }, {
                        "i": {"x": [0.3, 0.3], "y": [1, 1]},
                        "o": {"x": [0.7, 0.7], "y": [0, 0]},
                        "t": 135,
                        "s": [180, 180]
                    }, {"t": 150, "s": [100, 100]}],
                    "ix": 3
                },
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 3",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 3,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 10,
        "ty": 4,
        "nm": "Band 1",
        "parent": 13,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [155.25, 65.25, 0], "ix": 2},
            "a": {"a": 0, "k": [155.25, 25.25, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [[155, 25], [-155, 25], [-155, -25], [155, -25]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.532999973671, 0.588000009574, 0.638999968884, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 7')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [155.25, 25.25], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 11,
        "ty": 4,
        "nm": "Band 2",
        "parent": 13,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [155.25, 130.25, 0], "ix": 2},
            "a": {"a": 0, "k": [125.25, 17.75, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [[125, 17.5], [-125, 17.5], [-125, -17.5], [125, -17.5]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.922000002394, 0.922000002394, 0.922000002394, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 8')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [125.25, 17.75], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 12,
        "ty": 4,
        "nm": "Text",
        "parent": 13,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [155.25, 170.25, 0], "ix": 2},
            "a": {"a": 0, "k": [130.469, 5.469, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0]],
                        "v": [[5.469, 5.469], [255.469, 5.469]],
                        "c": false
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [0.372999991623, 0.4, 0.458999992819, 1],
                    "ix": 3,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 3')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 10.938, "ix": 5},
                "lc": 1,
                "lj": 2,
                "bm": 0,
                "d": [{"n": "d", "nm": "dash", "v": {"a": 0, "k": 172, "ix": 1}}, {
                    "n": "g",
                    "nm": "gap",
                    "v": {"a": 0, "k": 60, "ix": 2}
                }, {
                    "n": "o",
                    "nm": "offset",
                    "v": {
                        "a": 1,
                        "k": [{
                            "i": {"x": [0.3], "y": [1]},
                            "o": {"x": [0.7], "y": [0]},
                            "t": 2,
                            "s": [122]
                        }, {
                            "i": {"x": [0.3], "y": [1]},
                            "o": {"x": [0.7], "y": [0]},
                            "t": 17,
                            "s": [72]
                        }, {"i": {"x": [0.3], "y": [1]}, "o": {"x": [0.7], "y": [0]}, "t": 32, "s": [172]}, {
                            "t": 47,
                            "s": [122]
                        }],
                        "ix": 7
                    }
                }],
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [0, 0], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 13,
        "ty": 4,
        "nm": "Card",
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {
                "a": 1,
                "k": [{
                    "i": {"x": 0.3, "y": 1},
                    "o": {"x": 0.7, "y": 0},
                    "t": 0,
                    "s": [250, 175, 0],
                    "to": [0, 0, 0],
                    "ti": [0, 0, 0]
                }, {
                    "i": {"x": 0.3, "y": 1},
                    "o": {"x": 0.7, "y": 0},
                    "t": 15,
                    "s": [190, 175, 0],
                    "to": [0, 0, 0],
                    "ti": [0, 0, 0]
                }, {
                    "i": {"x": 0.3, "y": 1},
                    "o": {"x": 0.7, "y": 0},
                    "t": 30,
                    "s": [310, 175, 0],
                    "to": [0, 0, 0],
                    "ti": [0, 0, 0]
                }, {"t": 45, "s": [250, 175, 0]}],
                "ix": 2
            },
            "a": {"a": 0, "k": [155.25, 100.25, 0], "ix": 1},
            "s": {
                "a": 1,
                "k": [{
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 48,
                    "s": [100, 100, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 63,
                    "s": [120, 120, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 78,
                    "s": [0, 0, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 120,
                    "s": [0, 0, 100]
                }, {
                    "i": {"x": [0.2, 0.2, 0.2], "y": [1, 1, 1]},
                    "o": {"x": [0.8, 0.8, 0.8], "y": [0, 0, 0]},
                    "t": 135,
                    "s": [115, 115, 100]
                }, {"t": 150, "s": [100, 100, 100]}],
                "ix": 6
            }
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[8.118, 0], [0, 0], [0, 8.117], [0, 0], [-8.117, 0], [0, 0], [0, -8.117], [0, 0]],
                        "o": [[0, 0], [-8.117, 0], [0, 0], [0, -8.117], [0, 0], [8.118, 0], [0, 0], [0, 8.117]],
                        "v": [[140.241, 100], [-140.241, 100], [-155, 85.241], [-155, -85.241], [-140.241, -100], [140.241, -100], [155, -85.241], [155, 85.241]],
                        "c": true
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "fl",
                "c": {
                    "a": 0,
                    "k": [0.4, 0.769000004787, 1, 1],
                    "ix": 4,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller').effect('Color 9')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 5},
                "r": 1,
                "bm": 0,
                "nm": "Fill 1",
                "mn": "ADBE Vector Graphic - Fill",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [155.25, 100.25], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }, {
        "ddd": 0,
        "ind": 14,
        "ty": 4,
        "nm": "Line 2",
        "parent": 8,
        "sr": 1,
        "ks": {
            "o": {"a": 0, "k": 100, "ix": 11},
            "r": {"a": 0, "k": 0, "ix": 10},
            "p": {"a": 0, "k": [98.988, 50, 0], "ix": 2},
            "a": {"a": 0, "k": [50, 50, 0], "ix": 1},
            "s": {"a": 0, "k": [100, 100, 100], "ix": 6}
        },
        "ao": 0,
        "shapes": [{
            "ty": "gr",
            "it": [{
                "ind": 0,
                "ty": "sh",
                "ix": 1,
                "ks": {
                    "a": 0,
                    "k": {
                        "i": [[0, 0], [0, -27.056], [0, 0]],
                        "o": [[27.055, 0], [0, 0], [0, 0]],
                        "v": [[-24.494, -50], [24.494, -1.012], [24.494, 50]],
                        "c": false
                    },
                    "ix": 2
                },
                "nm": "Path 1",
                "mn": "ADBE Vector Shape - Group",
                "hd": false
            }, {
                "ty": "st",
                "c": {
                    "a": 0,
                    "k": [0.532999973671, 0.588000009574, 0.638999968884, 1],
                    "ix": 3,
                    "x": "var $bm_rt;\ntry {\n    $bm_rt = thisComp.layer('Controller')('Effects')('Color 7')('ADBE Color Control-0001');\n} catch (e) {\n    $bm_rt = value;\n}"
                },
                "o": {"a": 0, "k": 100, "ix": 4},
                "w": {"a": 0, "k": 20, "ix": 5},
                "lc": 1,
                "lj": 1,
                "ml": 10,
                "bm": 0,
                "nm": "Stroke 1",
                "mn": "ADBE Vector Graphic - Stroke",
                "hd": false
            }, {
                "ty": "tr",
                "p": {"a": 0, "k": [74.494, 100], "ix": 2},
                "a": {"a": 0, "k": [0, 0], "ix": 1},
                "s": {"a": 0, "k": [100, 100], "ix": 3},
                "r": {"a": 0, "k": 0, "ix": 6},
                "o": {"a": 0, "k": 100, "ix": 7},
                "sk": {"a": 0, "k": 0, "ix": 4},
                "sa": {"a": 0, "k": 0, "ix": 5},
                "nm": "Transform"
            }],
            "nm": "Group 1",
            "np": 2,
            "cix": 2,
            "bm": 0,
            "ix": 1,
            "mn": "ADBE Vector Group",
            "hd": false
        }],
        "ip": 0,
        "op": 150,
        "st": 0,
        "bm": 0
    }],
    "markers": []
}